import { render, staticRenderFns } from "./Pirates.vue?vue&type=template&id=4cda6f3f&"
import script from "./Pirates.vue?vue&type=script&lang=js&"
export * from "./Pirates.vue?vue&type=script&lang=js&"
import style0 from "./Pirates.vue?vue&type=style&index=0&id=4cda6f3f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports